export enum LogisticType {
    MEETUP = 'MEETUP',
    PICKUP_AND_MEETUP = 'PICKUP_AND_MEETUP',
    PICKUP = 'PICKUP',
    UNKNOWN = 'UNKNOWN',
}
